<template>
    <div style="background-color: #4B78FF;">
        <template v-for="(node,index) in nodes" v-if="node.id!=9" >
            <el-submenu :index="node.path"   v-if="!node.hidden&&node.children&&node.children.length>0">
                <template slot="title">
                    <i :class="node.icon"></i>
                    <span slot="title">{{node.name}}</span>
                </template>
                <menu-tree :nodes="node.children"></menu-tree>
            </el-submenu>
            <!-- 这里是用:route="{name:node.name}，如果不使用name跳转的话，可以在数据源那里把path写成全路径即可 -->
            <el-menu-item style="text-align: center;padding: 0px;" :index="node.path" @click="locationAdd(node.path)" v-if="!node.hidden&&node.children&&node.children.length==0&&$store.getters.ismobilePhone&&(node.name == '客戶' || node.name == '首頁')">
                    <i :class="node.icon"></i>
                    <span >{{node.name}}</span>
            </el-menu-item>
            <el-menu-item style="text-align: center;padding: 0px;" :index="node.path" @click="locationAdd(node.path)" v-else-if="!node.hidden&&node.children&&node.children.length==0&&$store.getters.ismobilePhone==false">

                <i :class="node.icon"></i>
                <span >{{node.name}}</span>

            </el-menu-item>
        </template>
    </div>
</template>
<script>
  export default {
    props:['nodes'],
    name: 'MenuTree',
    data() {
      return {
      }
    },
    methods: {
        locationAdd(path){
			
			
            this.$store.commit("setCollapsed",false);
            if(path == '/homepage'){
//                this.$router.push('/');
//                this.$store.commit("setSta",true);
//                this.$store.commit("setIsLoding",false);
                this.$store.commit("setSta",false);
                this.$store.commit("setIsLoding",true);
//                this.$router.push({
//                    name: '倉庫'
//                })
            }
            if(path == '/warehousing' ){
                this.$store.commit("setWarehouseSta",false);
                this.$store.commit("setCustomerInSte",false);
            }
            if(path == '/storOn'){
                this.$store.commit("setStoronSta",false);
                this.$store.commit("setCustomerOnSte",false);
            }
            if(path == '/customer'){
                this.$store.commit("setSta",false);
            }
            return;
        }
    }
  }

</script>

<style scoped lang="scss">
.fa{
    // color:#2d2f33;
}
.el-menu--collapse{
    div{
      .el-submenu{
        .el-submenu__title{
          span{
            height: 0;
            width: 0;
            overflow: hidden;
            visibility: hidden;
            display: inline-block;
          }
        }
      }
    }
  }
// .el-menu-item:hover span{ color:#4B78FF;}
// .el-menu-item { color:#FFF;padding:0px;}
//     .is-active{
//         background-color: #ffffff;
//         color:#4B78FF ;
//     }
</style>



// WEBPACK FOOTER //
// src/components/MenuTree.vue